<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    title="咨询线索"
    resource="inqueries"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Inquery extends Vue {
  @Prop(String) type;

  // form 新建咨询线索初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'name_cont',
        label: '名称',
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'email_cont',
        label: '邮箱',
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'mobile_cont',
        label: '手机',
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'message_cont',
        label: '内容',
        renderCell: {
          component: 'input'
        }
      }
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'id',
        label: '编号',
        width: 80,
      },
      {
        prop: 'name',
        label: '名称',
        width: 180,
      },
      {
        prop: 'email',
        label: '邮箱',
        renderCell: 'mail',
        width: 150,
      },
      {
        prop: 'mobile',
        label: '手机',
        width: 120,
      },
      {
        prop: 'message',
        label: '内容',
        width: 200,
      },
      {
        prop: 'created_at',
        label: '创建时间',
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      },
      {
        prop: 'updated_at',
        label: '更新时间',
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      }
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前咨询线索数据
   * @param {Function} params.change - 调用此方法同步咨询线索数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'name',
        label: '名称',
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'email',
        label: '邮箱',
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'mobile',
        label: '手机',
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'message',
        label: '内容',
        renderCell: {
          component: 'input'
        }
      }
    ];
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: '编辑',
          to: { name: 'inqueries.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: '删除',
          type: 'danger',
          can: 'inqueries.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}


export const route = [
  {
    path: '/inqueries',
    name: 'inqueries.index',
    component: Inquery,
    props: {
      type: 'index',
    }
  },
  {
    path: '/inqueries/new',
    name: 'inqueries.new',
    component: Inquery,
    props: {
      type: 'new',
    }
  },
  {
    path: '/inqueries/:id',
    name: 'inqueries.show',
    component: Inquery,
    props: {
      type: 'show',
    }
  },
  {
    path: '/inqueries/:id/edit',
    name: 'inqueries.edit',
    component: Inquery,
    props: {
      type: 'edit'
    }
  }
]
</script>
